import { Button, Card } from "@mui/material";
import React, { useCallback, useEffect, useState } from "react";
import { Form } from "react-bootstrap";
import axios from "axios";
import LoadingIcon from "../components/LoadingIcon";

const Verify = () => {
  const [file, setFile] = useState(null);
  const [userVerified, setUserVerified] = useState();
  const [loading, setLoading] = useState(false);
  const [userStatus, setUserStatus] = useState();
  const [pageLoading, setPageLoading] = useState(true);
  const token = localStorage.getItem("token");
  const options = {
    headers: { token: token },
  };
  const handleSelectFile = (e) => setFile(e.target.files[0]);
  const handleUpload = async (e) => {
    try {
      e.preventDefault();
      setLoading(true);
      const data = new FormData();
      data.append("my_file", file);

      const res = await axios.post(
        `${process.env.REACT_APP_API_URL}upload`,
        data,
        options
      );
      console.log(res);
      // setRes(res.data);
    } catch (error) {
      alert(error.message);
    } finally {
      setLoading(false);
      window.location.reload();
    }
  };

  const getVerification = useCallback(async () => {
    setPageLoading(true);
    const response1 = await fetch(`${process.env.REACT_APP_API_URL}dashboard`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        token,
      },
    });

    const response = await fetch(`${process.env.REACT_APP_API_URL}verify`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        token,
      },
    });

    const data = await response.json();
    const data1 = await response1.json();
    setUserVerified(data1.user.verified);

    setUserStatus(data.verification);

    // if (data.status) {
    //   // setTransactions(data.userTransactions);
    // }
    // setWallet(data.wallet);
    setPageLoading(false);
  }, [token]);

  useEffect(() => {
    getVerification();
  }, [getVerification]);

  return (
    <div className="min-h-screen">
      <div className="mb-9">
        <h3 className="font-bold text-2xl text-white">Verification Process</h3>
      </div>

      {pageLoading ? (
        <div className="h-screen flex items-center justify-center">
          <LoadingIcon />
        </div>
      ) : userVerified ? (
        <div className="text-white">Account Verified</div>
      ) : userStatus ? (
        <Card className="p-3 md:w-1/2 mx-auto">
          <div className="text-lg text-black">Verification in process...</div>
        </Card>
      ) : (
        <Card className="p-3 md:w-1/2 mx-auto !bg-[#1B4242]">
          <div className="mb-9">
            <h3 className="font-bold text-lg text-center text-white">
              Upload Identification
            </h3>
          </div>
          <Form onSubmit={handleUpload} encType="multipart/form-data">
            <div className="border p-2">
              <input
                id="file"
                type="file"
                accept="image/*"
                required
                onChange={handleSelectFile}
                multiple={false}
              />
            </div>
            <div className="text-red-600 font-bold text-sm italic text-center mb-10">
              Upload only images
            </div>
            <div className="flex justify-center">
              <Button
                type="submit"
                className="!bg-[#101010]"
                variant="contained"
              >
                {loading ? "Uploading..." : "Upload document"}
              </Button>
            </div>
          </Form>
        </Card>
      )}
    </div>
  );
};

export default Verify;
